export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f7190464fd6251d0e97f5ff2299057a6f01b059bc&name=fetchTypeahead!'